import { FC } from 'react';

import { RootProvider } from './providers/RootProvider';

const App: FC = () => (
  <>
    <title>Cropink</title>
    <RootProvider />
  </>
);

export default App;
